import { useEffect, useState } from "react";
import { toast } from "sonner";
import { API, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function ThisOrThat() {
  const { user } = useAuth();
  const [polls, setPolls] = useState([]);
  const load = () => API.get("/polls").then((r) => setPolls(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const vote = async (pid, choice) => {
    if (!user) { toast.error("Log in to vote"); return; }
    try { await API.post(`/polls/${pid}/vote`, { choice }); toast.success("Voted 💗"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  if (!polls.length) return null;
  const p = polls[0];
  const done = p.voted;
  const Opt = ({ side, opt, pct }) => (
    <button onClick={() => !done && vote(p.id, side)} disabled={done} data-testid={`poll-${side}`}
      className="relative flex-1 rounded-2xl overflow-hidden border-2 border-stone-200 hover:border-[#6A1B29] transition-colors group">
      {opt.image && <img src={opt.image} alt={opt.label} className="w-full h-32 object-cover" />}
      <div className="p-3 flex items-center justify-between"><span className="font-display font-semibold text-stone-900">{opt.label}</span>{done && <span className="text-sm font-bold text-[#6A1B29]">{pct}%</span>}</div>
      {done && <div className="absolute bottom-0 left-0 h-1 bg-[#6A1B29]" style={{ width: `${pct}%` }} />}
    </button>
  );
  return (
    <div className="bg-white border border-stone-200 rounded-2xl p-6" data-testid="this-or-that">
      <p className="text-xs font-semibold tracking-[0.25em] uppercase text-[#6A1B29]">This or That</p>
      <h3 className="font-display text-xl font-semibold text-stone-900 mt-1">{p.question}</h3>
      <div className="flex gap-3 mt-4">
        <Opt side="a" opt={p.option_a} pct={p.pct_a} />
        <div className="grid place-items-center text-stone-300 font-display text-lg">or</div>
        <Opt side="b" opt={p.option_b} pct={p.pct_b} />
      </div>
      {done && <p className="text-xs text-stone-400 mt-3 text-center">{p.total} girls voted</p>}
    </div>
  );
}
